export const prodPaymentKey =
  'pk_live_51RJpM4IMn0B5jg4i0EBlppc1CXpmJe9U4yaDHZrFTicPLJExXNHpPR6KOgb0RkSWc3m2W3ldtmJMykwSq88cOYuf00s7PEXlWw';
export const devPaymentKey =
  'pk_test_51PLgi9AK61lPlLRh3AxbjUhHRfOOlOFcXoJSHFyP8pMzAJwPFLa4gqkmZ3iT6jP0GE3BjPmsLZoQqZB7Lea5Kd3P00AcXU6gP2';

export const isStage = () =>
  window.location.host.includes('stage') ||
  window.location.host.includes('localhost') ||
  window.location.host.includes('dev');

const prefix = isStage() ? 'stage.' : '';
const https = `https://${prefix}api.mgkeld.com/api/`;
const socket = `wss://${prefix}api.mgkeld.com/ws/`;
const trackingApp = `https://${prefix}tracking.mgkeld.com/#/`;

export const PAYMENT_KEY = isStage() ? devPaymentKey : prodPaymentKey;

export const baseUrl = {
  https,
  socket,
  trackingApp,
  getDVRAppUrl: (domain: string | undefined) =>
    domain
      ? `https://camera.${
          domain.includes('mgk') ? 'reliableeld.com' : domain
        }/?scheme=reliable`
      : '',
};
